import { fromJS } from 'immutable'
import * as types from './action-types'

const InitialState = fromJS({
  rowSt: 0,
  rowIndex: 0,
  rowDeltas: []
})

export default (state = InitialState, action) => {
  switch (action.type) {
    case types.BG_UPDATE_CURRENT_ROW:
      return state.set('rowIndex', action.payload)

    case types.UPDATE_CURRENT_ROW:
      const { payload } = action

      const { index, delta, st } = payload
      const rows = state.get('rowDeltas')
      const updatedRows = rows.set(index, delta)

      return state
        .set('rowDeltas', updatedRows)
        .set('rowSt', st)
      
    default:
        return state
  }
}



// WEBPACK FOOTER //
// ./src/components/background-canvas/reducer.js